<template>
  <div v-if="category">
    <app-header
      :title="originalName ? 'Edit ' + originalName : 'New Film Type Category'"
      subtitle="Film Type Category"
    >
      <button :disabled="invalidForm" class="btn btn-primary" @click="save()">
        Save Changes
      </button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="6">
          <b-form name="editorForm">
            <!--Name-->
            <b-form-group>
              <label>Name</label>
              <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input v-model="category.name" required />
              <br />
              <label>
                Film types ({{ selectedFilmtypes.length }} selected)
              </label>
              <b-form-checkbox-group v-model="selectedFilmtypes" stacked>
                <b-form-checkbox
                  v-for="filmtype in filmtypes"
                  :key="filmtype.id"
                  :value="filmtype.id"
                >
                  {{ filmtype.hidden ? '[Hidden] ' : '' }}{{ filmtype.name }} -
                  {{ filmtype.description }} #{{ filmtype.id }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import AppHeader from '@/components/AppHeader';
import CancelButton from '@/components/CancelButton';

export default {
  components: {
    AppHeader,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      category: null,
      categories: [],
      filmtypes: [],
      selectedFilmtypes: [],
    };
  },

  computed: {
    invalidForm() {
      return !this.category.name;
    },
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      if (this.$route.query.id) {
        $api
          .get(`/v1/internal/filmtypecategories/${this.$route.query.id}`)
          .then((category) => {
            this.originalName = category.name;
            this.category = category;
            this.selectedFilmtypes = this.category.filmtypes.map(
              (f) => f.filmtype_id,
            );
          });
      } else {
        this.category = {};
      }
      const filmtypes = await $api.get('/v1/common/filmtypes');
      filmtypes
        .sort((a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? -1 : 1))
        .sort((a, b) => (a.hidden > b.hidden ? 1 : -1));
      this.filmtypes = filmtypes;
    },

    save() {
      this.category.filmtypes = this.selectedFilmtypes;
      if (this.category.id) {
        $api
          .put(
            `/v1/internal/filmtypecategories/${this.category.id}`,
            this.category,
          )
          .then((category) => {
            this.$router.push({
              name: 'filmtypecategory-list',
              params: category,
            });
          });
      } else {
        $api
          .post('/v1/internal/filmtypecategories/', this.category)
          .then((category) => {
            this.$router.push({
              name: 'filmtypecategory-list',
              params: category,
            });
          });
      }
    },
  },
};
</script>
